// Setup covers the whole companion. Old per-feature choices do not grant it.
export const CHROME_COMPANION_SETUP_VERSION = 'v2'

export const getChromeCompanionSetupKey = ({ accountId, userId }) =>
  accountId && userId
    ? `residesk:chrome-setup:${CHROME_COMPANION_SETUP_VERSION}:${accountId}:${userId}`
    : null

export function readChromeCompanionSetup(key) {
  try {
    return Boolean(key && window.localStorage.getItem(key) === 'accepted')
  } catch {
    return false
  }
}

export function acceptChromeCompanionSetup(key) {
  try {
    if (key) window.localStorage.setItem(key, 'accepted')
  } catch {
    // The mounted gate retains acceptance when storage is unavailable.
  }
}
